import { storeCopy } from '@/content/store-copy';

export function TrustStrip() {
  return (
    <section
      aria-label="Why buy here"
      className="border-y border-brand-line bg-ink px-[clamp(20px,4vw,64px)] py-9 max-[560px]:px-4"
    >
      <div className="mx-auto grid max-w-[1420px] grid-cols-3 gap-8 max-[860px]:grid-cols-1 max-[860px]:gap-5">
        {storeCopy.trust.map((item) => (
          <div key={item.title}>
            <p className="font-serif text-[1.05rem] text-gold-soft">{item.title}</p>
            <p className="mt-1 text-[0.85rem] leading-relaxed text-brand-muted">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
